import { render } from "./FilterItemObject.vue?vue&type=template&id=ff5978c8&scoped=true"
import script from "./FilterItemObject.vue?vue&type=script&lang=js"
export * from "./FilterItemObject.vue?vue&type=script&lang=js"

import "./FilterItemObject.vue?vue&type=style&index=0&id=ff5978c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5978c8"]])

export default __exports__